import React, { useEffect, useState } from 'react';
import { Field, FieldArray } from 'redux-form';
import { renderFieldDisabled, AsyncSelectField, SelectFieldAllFields, renderNumberSinFormatoDisabled, renderDollarDisabled } from '../../../../Utils/renderField/renderField';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { api } from "api";
import { months } from '../../../../Utils/months';


const TableRow = ({ system, index, fields, change }) => {

    const calculateTotalForRow = () => {
        const systemData = fields.get(index);
        if (!systemData) return 0;

        const totalForRow = months.reduce((accumulatedTotal, month) => {
            const value = parseFloat(systemData[month]) || 0;
            accumulatedTotal += value;
            return accumulatedTotal;
        }, 0);

        return totalForRow;
    };

    return (
        <React.Fragment key={index}>
            <tr key={`system-${index}`}>
                <td className="cell-cliente">
                    <Field
                        name={`${system}.customer.company`}
                        component={renderFieldDisabled}
                        type="text"
                        className="form-control"
                    />
                </td>
                <td className="cell-puerto">
                    <Field
                        name={`${system}.depure_port.name`}
                        component={renderFieldDisabled}
                        type="text"
                        className="form-control"
                    />
                </td>
                <td className="cell-transporte">
                    <Field
                        name={`${system}.type_of_transport.name`}
                        component={renderFieldDisabled}
                        type="text"
                        className="form-control"
                    />
                </td>
                <td className="cell-empaque">
                    <Field
                        name={`${system}.packing.name`}
                        component={renderFieldDisabled}
                        type="text"
                        className="form-control"
                    />
                </td>
                <td className="cell-diferencial text-left">
                    <Field
                        name={`${system}.differential`}
                        component={renderDollarDisabled}
                        className="form-control"
                        placeholder="0.0"
                    />
                </td>
                {months.map((month) => (
                    <td key={month} className="cell-mes">
                        <Field
                            name={`${system}.${month}`}
                            type="text"
                            component={renderNumberSinFormatoDisabled}
                            className="form-control"
                            placeholder="0.0"
                        />
                    </td>
                ))}
                <td className="cell-total text-right-padded">
                    {new Intl.NumberFormat('es-GT', { style: 'decimal',
                        maximumFractionDigits: 2,
                        minimumFractionDigits:2    }).format(calculateTotalForRow())}
                </td>
            </tr>
        </React.Fragment>
    );
};

const GenericTable = ({ fields, change }) => {

    const calculateTotalForMonth = (month) => {
        const allFields = fields.getAll() || [];
        const total = allFields.reduce((accumulatedTotal, system) => {

            const value = parseFloat(system[month]) || 0;
            accumulatedTotal += value
            return accumulatedTotal;
        }, 0);

        return total;
    };

    return (
        <div className="col-sm-12 form-group np-r p-0">
            <div className="table-responsive">
                <table className="table table-striped mb-0 text-center">
                    <thead>
                            <tr>
                                <th className="cell-cliente titulo-left-padded">CLIENTE</th>
                                <th className="cell-puerto titulo-left-padded">PUERTO DE SALIDA</th>
                                <th className="cell-transporte titulo-left-padded">TRANSPORTE</th>
                                <th className="cell-empaque titulo-left-padded">EMPAQUE</th>
                                <th className="cell-diferencial text-right">DIFERENCIAL</th>
                                {months.map((_, idx) => (
                                    <th className="cell-mes text-right-padded-lg" key={idx}>{idx + 1}</th>
                                ))}
                                <th className="cell-total text-right-padded">TOTAL</th>
                            </tr>
                        </thead>
                        <tbody>
                            {fields.map((system, index) => <TableRow key={index} system={system} index={index} fields={fields} change={change} />)}
                            <tr style={{ backgroundColor: "#F0FFC7" }}>
                                <td className="custom-cell text-center"></td>
                                <td className="custom-cell text-center"></td>
                                <td className="custom-cell text-center"></td>
                                <td className="custom-cell text-center"></td>
                                <td className="custom-cell text-center"></td>
                                {months.map((month, idx) => (
                                    <td key={idx} className="custom-cell text-right-padded">
                                        {new Intl.NumberFormat('es-GT', { style: 'decimal', 
                                            maximumFractionDigits: 2,
                                            minimumFractionDigits:2    }).format(calculateTotalForMonth(month))}
                                    </td>
                                ))}
                                <td className="custom-cell text-center"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            <div className="mt-2">
            </div>
        </div>
    );
}

const SalesTable = ({ fieldName, allValues, change }) => {
    return (
        <div>
            <FieldArray
                name={`${fieldName}`}
                component={GenericTable}
                allValues={allValues}
                change={change}
            />
        </div>
    );
}

const formName = 'SalesTable';

const selector = formValueSelector(formName);

const mapStateToProps = (state) => {
    const row_sales = selector(state, 'generic_row_sales') || [];
    const allValues = row_sales.map(item => item);
    return { allValues };
};

export default connect(mapStateToProps)(SalesTable);